import React from 'react';
import {Button} from '@mui/material';
import IntlMessages from 'util/IntlMessages';

const Footer = () => {
        return (
            <footer className="app-footer">
                <div className="d-flex flex-row justify-content-between">
                    <div>
                        <span> Copyright MID &copy; 2018</span>

                    </div>
                    
                </div>
            </footer>
        );
    }
;

export default Footer;
